<script lang="ts" setup>
import {computed, ref, toRefs} from 'vue';
import {useSession} from '/src/core/session';
import {logEvent} from '/src/utils';

const session = useSession();
const {state} = session;
const {auth, subscription} = toRefs(state);

const isAnnual = ref(false);

const isSubscriptionActive = computed(() => !!subscription.value && subscription.value?.status !== 'expired');

function logBuyBasic() {
    logEvent('button_buy', 'BASIC');
}

function logBuyPlus() {
    logEvent('button_buy', 'PLUS');
}

function buyPlus() {
    if (!auth.value) {
        return;
    }
    const {email, id} = auth.value.user;
    const plusURL = `${import.meta.env.VITE_CHECKOUT_URL}?checkout[email]=${email}&checkout[custom][user_id]=${id}`;
    window.location.href = plusURL;
}

function toggleAnnual() {
    isAnnual.value = !isAnnual.value;
}
</script>

<template>
    <slot></slot>
    <div class="flex flex-col mt-4 justify-around gap-4 sm:divide-secondary sm:divide-x sm:flex-row">
        <div class="flex flex-col justify-between mb-4 sm:mb-0">
            <div>
                <div class="text-2xl font-bold capitalize pl-14 md:pl-0">Basic</div>
                <div class="my-4 pl-16 sm:pl-0">
                    <div class="font-bold">Editor</div>
                    <ul class="list-disc list-inside">
                        <li>Code Generation</li>
                        <li>Image Processing</li>
                    </ul>
                    <div class="font-bold mt-2">Storage</div>
                    <ul class="list-disc list-inside">
                        <li>1 Public Project</li>
                        <li>5 Public Screens</li>
                    </ul>
                    <div class="font-bold mt-2">Assets</div>
                    <ul class="list-disc list-inside">
                        <li>Community Fonts</li>
                        <li>Community Icons</li>
                    </ul>
                </div>
            </div>
            <div class="text-center">
                <div class="font-bold text-info text-center">FREE</div>
                <div
                    v-if="auth && !isSubscriptionActive"
                    class="btn btn-disabled btn-wide mt-4 uppercase"
                >
                    Current plan
                </div>
                <router-link
                    v-if="!auth"
                    class="btn btn-outline btn-primary btn-wide mt-4 uppercase"
                    @click="logBuyBasic"
                    to="/login"
                >
                    Sign Up
                </router-link>
            </div>
        </div>
        <div class="sm:pl-4 flex flex-col justify-between mb-4 sm:mb-0">
            <div>
                <div class="text-2xl text-success font-bold capitalize pl-14 md:pl-8">Plus</div>
                <div class="my-4 pl-16 sm:pl-4 md:pl-8">
                    <div class="font-bold">Everything in Basic and...</div>
                    <div class="font-bold mt-2">Unlimited Storage</div>
                    <ul class="list-disc list-inside">
                        <li>Unlimited Projects</li>
                        <li>Unlimited Screens</li>
                    </ul>
                    <div class="font-bold mt-2">Private Projects and Screens</div>

                    <div class="font-bold mt-2 flex">Custom Fonts (GFX, BDF, TrueType)</div>
                    <div class="font-bold mt-2 flex">Export as a file</div>
                    <div class="font-bold mt-2">Presentation mode</div>
                    <div class="font-bold mt-2">Priority Support</div>
                    <!-- <div class="font-bold mt-2">No Ads</div> -->
                </div>
            </div>
            <div class="text-center">
                <!-- <div class="indicator-item badge badge badge-success font-bold mb-2">50% OFF</div> -->
                <div
                    v-if="isAnnual"
                    class="font-bold text-center"
                >
                    <span class="text-xl text-success">$49.95</span>
                    / year
                </div>
                <div
                    v-else
                    class="font-bold text-center"
                >
                    <!-- <span class="text-md line-through">&nbsp;$ 5.95&nbsp;</span>
                    &nbsp; -->
                    <span class="text-xl text-success">$5.95</span>
                    / month
                </div>
                <div
                    v-if="isAnnual"
                    class="text-primary link"
                    @click="toggleAnnual"
                >
                    Or pay monthly
                </div>
                <div
                    v-else
                    class="text-primary link"
                    @click="toggleAnnual"
                >
                    Save
                    <span class="">30%</span>
                    with annual payment
                </div>
                <div
                    v-if="auth && isSubscriptionActive"
                    class="btn btn-disabled btn-wide mt-4 uppercase"
                >
                    Current plan
                </div>
                <div
                    v-if="auth && !isSubscriptionActive"
                    class="btn btn-success btn-wide mt-4 uppercase"
                    @click="
                        logBuyPlus();
                        buyPlus();
                    "
                >
                    Buy Now
                </div>
                <router-link
                    to="/login#buy"
                    v-if="!auth && !isSubscriptionActive"
                    class="btn btn-success btn-wide mt-4 uppercase"
                    @click="logBuyPlus"
                >
                    Sign Up
                </router-link>
            </div>
        </div>
        <!-- <div class="pl-4 flex flex-col justify-between">
                    <div class="text-xl text-center text-primary">PRO</div>
                    <div class="my-4 pl-4">
                        <div class="font-bold">Everything in Plus and...</div>
                        <div class="font-bold mt-2">Team Workspace</div>
                        <ul class="list-disc list-inside">
                            <li>Collaboration</li>
                        </ul>
                        <div class="font-bold mt-2">Assets Manager</div>
                        <ul class="list-disc list-inside">
                            <li>HD Icon Packs</li>
                            <li>Unlimited Fonts</li>
                            <li>Components library</li>
                        </ul>
                        <div class="font-bold mt-2">Prototyping</div>
                        <ul class="list-disc list-inside">
                            <li>Interactive prototypes</li>
                            <li>User flow diagrams</li>
                        </ul>
                    </div>
                    <div class="font-bold text-success text-center">
                        $<span class="text-xl">{{ PRICE }}</span> / month
                    </div>
                    <div class="btn btn-primary btn-wide mt-4 uppercase" @click="buyPro">
                        JOIN WAITLIST
                    </div>
                </div> -->
    </div>
</template>
